var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailGetHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3332 14.9999C28.3332 14.0833 27.5832 13.3333 26.6665 13.3333H13.3332C12.4165 13.3333 11.6665 14.0833 11.6665 14.9999V24.9999C11.6665 25.9166 12.4165 26.6666 13.3332 26.6666H26.6665C27.5832 26.6666 28.3332 25.9166 28.3332 24.9999V14.9999ZM26.6665 14.9999L19.9998 19.1666L13.3332 14.9999H26.6665ZM26.6665 24.9999H13.3332V16.6666L19.9998 20.8333L26.6665 16.6666V24.9999Z",
    fill: "#32363E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGetHelp);
export default __webpack_public_path__ + "static/media/EmailGetHelp.87e8115cfab7bc72091081c3acad93ba.svg";
export { ForwardRef as ReactComponent };